import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as callActions from "../../actions/callActions";
import * as contractActions from "../../actions/contractActions";
import * as userActions from "../../actions/userActions";
import * as projectActions from "../../actions/projectActions";
import * as customerActions from "../../actions/customerActions";
import * as codeActions from "../../actions/codeActions";
import * as serviceActions from "../../actions/serviceActions";
import CallForm from "./CallForm";
import HeaderWrapper from "../common/HeaderWrapper";
import { customToast as toast } from "../../utils";

const CallAddPage = ({
  customers,
  services,
  users,
  actions,
  contracts,
  projects,
  codes,
  auth,
  history,
  saving
}) => {
  useEffect(() => {
    if (!projects.length) actions.loadProjects();
    if (!contracts.length) actions.loadContracts();
    if (!customers.length) actions.loadCustomers();
    if (!services.length) actions.loadServices();
    if (!users.length) actions.loadUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreate = async (call) => {
    try {
      if (call.tasks?.find((task) => !task.service_task)) {
        throw new Error("All fields on tasks are required");
      } else if (!call.tasks?.length) {
        throw new Error("Please add some tasks");
      }
      await actions.createCall(call);
      const params = new URLSearchParams(window.location.search);
      if (params.has("ref")) {
        history.push(`${params.get("ref")}`);
      } else {
        history.push("/app/dashboard");
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleCreateWithRecurring = async (call, recurrence) => {
    await actions.createRecurringCalls(call, recurrence);
    const params = new URLSearchParams(window.location.search);
    if (params.has("ref")) {
      history.push(`${params.get("ref")}`);
    } else {
      history.push("/app/dashboard");
    }
  };

  return (
    <React.Fragment>
      <HeaderWrapper breadcrumbs={[{ label: "Create Call" }]} />
      <div className="content-wrapper">
        <CallForm
          call={{}}
          customers={customers}
          services={services}
          users={users}
          codes={codes}
          auth={auth}
          actions={actions}
          contracts={contracts}
          projects={projects}
          onAdd={handleCreate}
          onAddWithRecurring={handleCreateWithRecurring}
          onCancel={history.goBack}
          editing
          adding
          saving={saving}
        />
      </div>
    </React.Fragment>
  );
};
CallAddPage.propTypes = {
  customers: PropTypes.array,
  services: PropTypes.array,
  users: PropTypes.array,
  actions: PropTypes.object,
  contracts: PropTypes.array,
  projects: PropTypes.array,
  codes: PropTypes.array,
  auth: PropTypes.object,
  history: PropTypes.object,
  saving: PropTypes.bool
};
function mapStatesToProps(state) {
  return {
    state: state.reducers,
    auth: state.reducers.auth,
    saving: state.reducers.savingCall,
    customers: state.reducers.customers,
    contracts: state.reducers.contracts,
    projects: state.reducers.projects,
    services: state.reducers.services,
    users: state.reducers.users,
    codes: state.reducers.codes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...callActions,
        ...customerActions,
        ...contractActions,
        ...projectActions,
        ...serviceActions,
        ...userActions,
        ...codeActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(CallAddPage);
